export interface TechnicalSaleRoleDomain {
  expertise_domains?: string
  role?: string
}

export function formattedExpertiseDomains(technicalSale: TechnicalSaleRoleDomain) {
  if (technicalSale.expertise_domains) {
    return technicalSale.expertise_domains.replace(/\|/g, ', ')
  }
  return ''
}

export function formattedRoleExpertiseDomains(technicalSale: TechnicalSaleRoleDomain) {
  const expertises: string[] = []
  const expertiseDomains = technicalSale.expertise_domains ? formattedExpertiseDomains(technicalSale) : ''
  const role = technicalSale.role ? technicalSale.role.trim() : ''
  if (role) {
    expertises.push(role)
  }
  if (expertiseDomains) {
    expertises.push(expertiseDomains)
  }
  return expertises.join(' ').trim()
}
